import { Component, Prop, Vue } from 'vue-property-decorator'

import { ArticleAuthor } from '../ArticleAuthor'
import { ArticleSource } from '../ArticleSource'
import { Author } from '../../_contracts'
import { PublicationDate } from '../PublicationDate'
import { CreatesPdf, PdfObject } from '../../../services'
import { ActionButton, IActionButton } from '../ActionButton'

@Component<ArticleMeta>({
  name: 'ArticleMeta',
  components: { ActionButton, ArticleAuthor, ArticleSource, PublicationDate },

  template: `
    <div class="article-meta">
      <ArticleAuthor
        class="article-meta__author"
        :author="author"
        :showInitialsWhenNoAvatar="true"
        :hideDate="hideDate"
        :showReadingTime="false"
      />

      <div class="article-meta__meta">
        <PublicationDate v-if="!hideDate" :value="publicationDate" />

        <ArticleSource v-if="source" :source="source" :siteName="siteName" />

        <ActionButton v-if="pdfAction" class="d-md-none" v-bind="pdfAction" />
      </div>
    </div>
  `
})
export class ArticleMeta extends Vue {
  @Prop({ type: Object, required: true })
  public readonly author!: Author

  @Prop({ type: String, required: true })
  public readonly siteName!: string

  @Prop({ type: String, required: false, default: null })
  public readonly source!: string | null

  @Prop({ type: String, required: false, default: false })
  protected readonly publicationDate!: string

  @Prop({ type: Boolean, required: false, default: false })
  protected readonly hideDate!: boolean

  @Prop({ type: Object, required: false, default: null })
  protected readonly pdf!: PdfObject | null

  @Prop({ type: Object, required: false, default: null })
  public readonly pdfService!: CreatesPdf

  public get pdfAction (): IActionButton | null {
    if (!this.pdf) {
      return null
    }

    return {
      callback: () => {
        if (this.pdfService && this.pdf) {
          return this.pdfService.download(this.pdf)
        }
      },
      disabled: !this.pdf.path,
      icon: 'download-new',
      title: 'PDF'
    }
  }
}
